<div>Iskorišteno {{ iskoristenProstorStr }} od {{ ukupanProstorStr }}</div>
<div class="p-mt-3">
  <p-progressBar  [ngClass]="'progress'" value="{{ procenat }}"></p-progressBar>
</div>
